<template>
  <modal class="login-dialog-modal" name="login-dialog" :adaptive="true" :scrollable="true" height="auto"
    :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeLoginDialog" icon="el-icon-circle-close-outline" style="font-size: 2rem; position: relative;right: 10px;" type="text"></el-button>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <div class="text-center button-download-wrapper">
        <login-forms />
      </div>
    </div>
  </modal>
</template>

<script>
import LoginForms from '@/components/LoginSpecialForms'

export default {
  name: 'LoginDialog',
  components: {
    'login-forms': LoginForms
  },
  data () {
    return {
      fullscreenLoading: false,
      isProcessingEvent: false // イベント処理中かどうかのフラグ
    }
  },
  methods: {
    openLoginDialog (context) {
      console.log('[LoginDialog openLoginDialog] コンテキスト:', context)
      
      // イベント処理中の場合は何もしない（無限ループ防止）
      if (this.isProcessingEvent) {
        console.log('[LoginDialog openLoginDialog] 既に処理中のため、スキップします')
        return
      }
      
      this.isProcessingEvent = true
      
      // FormatEditコンポーネントにコンテキストを渡す
      if (context) {
        this.$eventHub.$emit('set-login-context', context)
      }
      
      // モーダルを直接表示する
      this.$modal.show('login-dialog')
      
      // フラグをリセット
      setTimeout(() => {
        this.isProcessingEvent = false
      }, 100)
    },
    closeLoginDialog () {
      this.$eventHub.$emit('close-login-dialog')
      this.$eventHub.$emit('login-dialog-closed')
      this.$modal.hide('login-dialog')
    },
    handleBeforeClose (event) {
      // モーダルが閉じられる前に実行される処理
      this.$eventHub.$emit('close-login-dialog')
      this.$eventHub.$emit('login-dialog-closed')
    },
    handleAuthStateChanged (user) {
      console.log('handleAuthStateChanged')
      if (user) {
        console.log('login-success')
        this.$modal.hide('login-dialog')
        this.$eventHub.$emit('login-success')
      }
    }
  },
  beforeMount () {
    this.$eventHub.$on('open-login-dialog', this.openLoginDialog)
    this.$eventHub.$on('popstate', this.closeLoginDialog)
    this.$eventHub.$on('auth_state_changed', this.handleAuthStateChanged)
  },
  destroyed () {
    this.$eventHub.$off('open-login-dialog', this.openLoginDialog)
    this.$eventHub.$off('popstate', this.closeLoginDialog)
    this.$eventHub.$off('auth_state_changed', this.handleAuthStateChanged)
  }
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
  padding-top: 25px;
}

.v--modal-close-top {
  position: absolute;
  right: 0;
  top: 0;
}

.login-dialog-modal {
  ::v-deep .v--modal {
    margin: 20px;
    width: auto !important;
    border-radius: 8px;
    padding: 20px;
    max-width: 600px;
  }
}

.button-download-wrapper {
  .button-download-pdf {
    padding: 0;
    background: none;

    .login {
      padding: 0;
      width: 100%;
    }
  }
}
</style>
